import { Box, Grid } from '@mui/material'
import RecruitmentDrawerComponent from './RecruitmentDrawerComponent'
import TalentDetailDrawer from './TalentDetailDrawer'
import CandidateListDrawer from './CandidateListDrawer'
import AdxDrawerComponent from 'components/reusable/drawer/AdxDrawerComponent'

const CandidateDrawer = ({
  drawerState,
  handleDrawer,
  data,
  changeApplicantDetail,
  mappedData,
  handleDrawerClose,
  title = 'test123',
  count = '0',
  jobId,
  isChoosenName,
  isChoosenId,
  setSearch,
  error,
  isLoading,
  searchItem,
  setSearchItem,
}) => {
  return (
    <Box>
      <RecruitmentDrawerComponent
        state={drawerState}
        onClose={handleDrawer}
        width={{ lg: 1050 }}
        anchor="right"
        sxIcon={{ marginRight: 6.25, marginY: 6.25, height: 1 }}
      >
        <Grid container>
          <Grid item xs={4} sx={{ zIndex: 10 }}>
            <CandidateListDrawer
              title={title}
              count={count}
              changeApplicantDetail={changeApplicantDetail}
              mappedData={mappedData ?? []}
              jobId={jobId}
              isChoosenName={isChoosenName}
              isChoosenId={isChoosenId}
              setSearch={setSearch}
              isLoading={isLoading}
              error={error}
              //need search item to be passed in drawer because search function is accessible in the table and also drawer
              searchItem={searchItem}
              setSearchItem={setSearchItem}
            />
          </Grid>
          <Grid item xs={8}>
            <TalentDetailDrawer
              data={data}
              status={data?.job_application_status_id}
              id={data?.id}
              changeApplicantDetail={changeApplicantDetail}
              handleDrawerClose={handleDrawerClose}
              mappedData={mappedData ?? []}
              title={title}
            />
          </Grid>
        </Grid>
      </RecruitmentDrawerComponent>
    </Box>
  )
}
export default CandidateDrawer
